import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GrupoCarteiraService } from "src/app/grupo-carteira/grupo-carteira.service";
import { ToastService } from "maps-angular-components";
import { AssociacaoGrupoCarteiraVO } from "src/app/grupo-carteira/associacao-grupo-carteira";
import { BehaviorSubject } from "rxjs";
import { indicate } from "src/app/shared/util/loading-indicate";

@Component({
  selector: "modal-deletar-associacao-grupo-carteira",
  templateUrl: "./modal-deletar-associacao-grupo-carteira.component.html",
})
export class ModalDeletarAssociacaoGrupoCarteiraComponent {

  @Output()
  public readonly associacaoGrupoCarteiraExcluida = new EventEmitter();

  public readonly loadingDelete$ = new BehaviorSubject(false);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data: AssociacaoGrupoCarteiraVO,
    private readonly service: GrupoCarteiraService,
    private readonly toastService: ToastService,
  ) {
  }

  excluir() {
    this.service
      .excluirAssociacaoGrupoCarteira(this.data)
      .pipe(indicate(this.loadingDelete$))
      .subscribe(
        () => {
          this.toastService.textoLight("Exclusão da associação enviada para autorização!");
          this.associacaoGrupoCarteiraExcluida.emit()
        },
        error => this.toastService.erro(error.error.message),
      )
  }
}
